/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_Shipping_MethodInputs */

const en_po_field_shipping_method = /** @type {(inputs: Po_Field_Shipping_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping method`)
};

/**
* | output |
* | --- |
* | "Shipping method" |
*
* @param {Po_Field_Shipping_MethodInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_shipping_method = /** @type {((inputs?: Po_Field_Shipping_MethodInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_Shipping_MethodInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_shipping_method(inputs)
});